import { forwardRef } from 'react'
import { CalendarIcon, ChevronDownIcon } from 'lucide-react'
import { Button, cn } from '@wellesley/ui'
import { formatDateValue } from '../../helpers/dateFormatters'
import type { DatePickerTriggerProps } from '../../types/dataPicker'

export const DatePickerTrigger = forwardRef<
  HTMLButtonElement,
  DatePickerTriggerProps
>(({ value, placeholder, className, icon, ...props }, ref) => {
  const getMode = () => {
    if (!value) return 'single'
    if (Array.isArray(value)) return 'multiple'
    if (typeof value === 'object' && 'from' in value) return 'range'
    return 'single'
  }

  const formattedValue = formatDateValue(getMode(), value, placeholder)

  return (
    <Button
      ref={ref}
      variant="secondary"
      className={cn(
        'rounded-m py-l w-[280px] justify-between border border-gray-200 bg-white text-left font-normal text-gray-900',
        className,
      )}
      {...props}
    >
      <span className="gap-xxs flex items-center">
        {icon || <CalendarIcon size={16} />}
        {formattedValue}
      </span>
      <ChevronDownIcon size={20} className="ml-xxs" />
    </Button>
  )
})

DatePickerTrigger.displayName = 'DatePickerTrigger'
